import { Component, OnInit, Input, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { DeleteaddressComponent } from '../../../dialogs/client-address/deleteaddress/deleteaddress.component';
import { MediaObserver } from '@angular/flex-layout';
import { MyStripeService } from 'src/app/services/apiclient/myStripe/my-stripe.service';
import { StripeCardScaComponent } from 'src/app/components/dialogs/stripe-card-sca/stripe-card-sca.component';

@Component({
  selector: 'app-cards-endorder',
  templateUrl: './cards-endorder.component.html',
  styleUrls: ['./cards-endorder.component.css']
})
export class CardsEndorderComponent implements OnInit {

  @Output() setClientCardsEvent = new EventEmitter<any[]>();
  @Output() selectPaymentEvent = new EventEmitter<any | string>();

  @Input()
  clientCards$: any;

  @Input()
  showDelete: boolean = true;


  @Input()
  from: string | any;

  @Input()
  currPaymentMethod: any;

  cardClient$: any;

  showCardList: boolean = false;

  // RESPONSIVE
  respCols: any = {
    "xs": 1,
    "sm": 2,
    "md": 2,
    "lg": 3,
    "xl": 4
  };

  currCols: number = (this.media.isActive("xs")) ? 1 : 2;
  rowHeight: number = 150;
  loader: boolean = true;

  constructor(
    private dialog: MatDialog,
    private media: MediaObserver,
    private cardApi: MyStripeService
  ) {
    this.media.asObservable().subscribe((media: any) => {
      this.currCols = this.respCols[media.mqAlias];
    });
  }

  ngOnInit() {
    if (this.from !== "client") {
      this.cardApi.getCurrCard().subscribe(card => {
        this.cardClient$ = card;
      
      });
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
 
    if (changes["clientCards$"] && changes["clientCards$"].currentValue) {
      this.loader = false;
    }

   
    if (changes["currPaymentMethod"] && changes["currPaymentMethod"].currentValue!=='secure_counter' ) {
    
      this.showCardList=false;
    }
  }

  selectCardClient(card: any) {

  
    if (this.from !== "client") {

      this.cardApi.setCurrCard(card);

    }
    this.showCardList = false;
  }

  openDialCardSca() {
    
    const myConf = new MatDialogConfig();
    this.media.isActive("xs")
        ? (myConf.width = "100%", myConf.height = "100%")
        : (myConf.width = "550px", myConf.height = "80%");
    const myDial = this.dialog.open(StripeCardScaComponent, myConf);
    myDial.afterClosed().subscribe(result => {

      if (result) {

        if (result.from === "saved") {

          this.setClientCards(result.cards);

        } else if (result.from === "momentary") {

          this.clientCards$.push(result.card);
          this.setClientCards(this.clientCards$);

        }

      }

    });
  }

  openDialDeletCard(card: any, index: number) {
    const myConf = new MatDialogConfig();
    myConf.autoFocus = false;
    myConf.data = {
      from: "card",
      card: card,
      cards: this.clientCards$,
      index: index,
      currCard: this.cardClient$
    };
    this.media.isActive("xs") ? myConf.width = "100%" : myConf.width = "500px";
    const myDial = this.dialog.open(DeleteaddressComponent, myConf);
    myDial.afterClosed().subscribe(data => {
    
      if (data) {
        this.setClientCards(data);
      }
    });
  }

  setClientCards(cards: any[]) {
    this.setClientCardsEvent.emit(cards);
  }
}
